import { Application, modulePage } from "../../../../../../../../resources/ts/core/Application";
import { search } from "../../../../../../../../resources/ts/website/components/Search";
import { Recaptcha } from "../../../../../../../../resources/ts/website/components/Recaptcha";
import { helper } from "../../../../../../../../resources/ts/core/Helper";
import { Newsletter } from "../../../../../../../../resources/ts/website/components/Newsletter";
import { Banner } from "../../../../../../../../resources/ts/website/components/Banner";
import { Modal } from "bootstrap";

class Main implements modulePage {
    name: string = "Main";
    cookieName: string = "accept-cookies";

    private documentEvents = () => {
        search.init();
    }

    private cookiePopup() {
        if (helper.getCookie("void") === "") {
            return;
        }

        if (helper.getCookie(this.cookieName) === "") {
            const cookiePopup = document.getElementById("cookie-popup") as HTMLLinkElement;
            const acceptBtn = document.getElementById("cookie-accept") as HTMLLinkElement;
            const refuseBtn = document.getElementById("cookie-refuse") as HTMLLinkElement;

            cookiePopup.classList.remove("d-none");

            acceptBtn.addEventListener("click", (e) => {
                e.preventDefault();
                cookiePopup.classList.add("d-none");
                this.setAcceptCookie(true);
                window.gTagConsent();
            });

            refuseBtn.addEventListener("click", (e) => {
                e.preventDefault();
                cookiePopup.classList.add("d-none");
                this.setAcceptCookie(false);
                window.gTagConsent();
            });
        }
    }

    private setAcceptCookie(accepted: boolean) {
        this.marketingPopup();
        const gValue = accepted ? "granted" : "denied";
        helper.setCookie(this.cookieName, gValue, 365);
    }

    private marketingPopup() {
        if (helper.getCookie("newsletter-shown") === "" && helper.getCookie(this.cookieName) !== "") {
            helper.setCookie("newsletter-shown", (new Date()).toString(), 15);
            setTimeout(() => {
                const modalItem = document.getElementById("newsletterModal");
                if (modalItem) {
                    const modal = Modal.getOrCreateInstance(modalItem);
                    modal.show();
                }
            }, 5000);
        }
    }

    init = () => {
        this.cookiePopup();
        this.documentEvents();
        //this.marketingPopup();
    };

}

document.addEventListener("DOMContentLoaded", function () {
    window.app = window.app ?? new Application();
    window.app.addModules([new Main(), new Recaptcha(), new Banner(), new Newsletter()]);
    window.app.start();
});